export function removeUserConnection(oldData, { connectorName, connectionUUID }) {
    if (!oldData)
        return oldData;
    return {
        ...oldData,
        sources: oldData.sources.map((source) => {
            if (source.id !== connectorName)
                return source;
            if (!('user_connections' in source))
                return source;
            return {
                ...source,
                user_connections: source.user_connections?.filter((connection) => connection.connection_uuid !== connectionUUID),
            };
        }),
    };
}
//# sourceMappingURL=disconnect.js.map